import postAppMessage from '@/tools/post-app-message'
import getWebviewVendor from '@/tools/get-webview-vendor'

let linkHandler

function createLinkHandler(element, binding) {
  return (event) => {
    const isWebview = !!getWebviewVendor()

    if (isWebview) {
      event.preventDefault()

      postAppMessage('open_universal_link', {
        v1: {
          url: element.href,
          fallback: binding.value
        }
      })
    }
  }
}

export default {
  bind: function(element, binding) {
    linkHandler = createLinkHandler(element, binding)
    element.addEventListener('click', linkHandler)
  },
  unbind: function(element) {
    element.removeEventListener('click', linkHandler)
  }
}
